// -- React Libraries
import React from 'react';

// -- Components
import AppInfo from "../AppInfo/index";

// -- Styles
import StyleWrapper from "./Wrapper";

export default class OrderSummary extends React.Component {
    render() {
        return (
            <StyleWrapper className="order-summary">
              <AppInfo
                appName={this.props.appName}
                imgUrl={this.props.imgUrl}
              />

              <div className="price">
                Total Amount:
                $ {this.props.price}
              </div>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/OrderSuccess/OrderSummary/index.js